<section class="container animated fadeIn">
  <p class="font-weight-lighter">* El precio no incluye actualizaciones generales (Entiendase cambios grandes en los sistemas del SRI) del sistema de facturación o actualización a otras versiones superiores.</p>
</section>
